const newsList = document.querySelector('.sc-news-list');

if (newsList) {
  const listInner = newsList.querySelector('.news-list__body');
  const listFooter = newsList.querySelector('.news-list__footer');
  const initialCategory = newsList.getAttribute('data-initial-category') || '';

  const loadPage = async (pageNumber) => {
    try {
      const { data } = await axios.post(localData.siteURL, {
        action: 'getMoreNews',
        initialCategoryData: initialCategory,
        pageNumber,
      });

      if (data.data.html_list) {
        listInner.innerHTML = data.data.html_list;
      }

      if (listFooter && data.data.html_pagination) {
        listFooter.innerHTML = data.data.html_pagination;
      }

      newsList.scrollIntoView({ behavior: 'smooth' });

      const url = new URL(window.location.href);
      url.searchParams.set('paged', pageNumber);
      window.history.pushState({}, '', url.toString());
    } catch (err) {
      console.error(err);
    }
  };

  attachEvent('.sc-news-list .pagination .page-numbers', 'click', (ev) => {
    ev.preventDefault();
    const pageNumber = ev.target.closest('[data-page]')?.dataset.page;
    if (pageNumber) {
      loadPage(pageNumber);
    }
  });
}
